import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Field, FieldError, FieldLabel } from '@/components/shadcn/field';
import { Input } from '@/components/shadcn/input';

export default function LegalPartyFields() {
  const { t } = useTranslation();

  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Field data-invalid={errors.companyName ? true : undefined}>
      <FieldLabel htmlFor="companyName">
        {t('PARTY_CREATE_INLINE_COMPANY_NAME_LABEL')}
        {' *'}
      </FieldLabel>

      <Input
        id="companyName"
        {...register('companyName', {
          required: t('PARTY_CREATE_INLINE_REQUIRED'),
        })}
      />

      <FieldError
        errors={errors.companyName ? [errors.companyName] : undefined}
      />
    </Field>
  );
}
